export const OGRN_LENGTH = 13
export const INN_UL_LENGTH = 10
export const INN_FL_LENGTH = 12
export const SNILS_LENGTH = 11
export const KPP_LENGTH = 9
export const INDEX_LENGTH = 6
export const PHONE_LENGTH = 10
export const DEPOT_CODE_LENGTH = 1
export const YEAR_CODE_LENGTH = 1
export const BANK_ACCOUNT_LENGTH = 20
export const BANK_CORP_ACCOUNT_LENGTH = 23
export const BIK_LENGTH = 9
export const KBK_LENGTH = 20
export const OKTMO_LENGTH = 11
